import React, { useState } from "react";
import styles from "./Careers.module.css";
import { FaGlobeAsia } from "react-icons/fa";
import { useEffect } from "react";
import { isEmpty } from "lodash";

const Careers = () => {
  const [selected, setSelected] = useState();
  const [careersData, setCareersData] = useState([]);

  useEffect(() => {
    const edTechJobMathsSchools = {
      id: 0,
      jobTitle: "BDE/BDM EdTech (Maths – Schools)",
      skill: [
        "2+ years of experience in BPO, Sales, Counseling, EdTech, BFSI, FinTech, or Travel",
        "Excellent verbal and written communication skills",
        "Proficiency in MS Office, especially Microsoft Excel",
        "Target-driven mindset with a consultative sales approach",
        "Passion for education, learning, and growing emerging brands in the K–12 maths space",
      ],
      description: [
        "Drive inquiries and admissions for maths-focused online and blended learning programs for K–12 schools.",
        "Manage the end-to-end sales lifecycle from first school contact to final enrollment.",
        "Engage with qualified inbound leads from schools via calls and emails.",
        "Provide guidance to school decision-makers and recommend suitable maths learning solutions and programs.",
        "Build strong relationships with schools and deliver an excellent learner experience.",
        "Update and maintain MIS reports and CRM data accurately.",
      ],
      location: "Remote/Onsite, India",
    };

    const growthManagerEdTech = {
      id: 1,
      jobTitle: "Growth Manager – EdTech",
      skill: [
        "2–3 years of experience in an EdTech company, focusing on product or growth-related roles",
        "Strong understanding of online learning landscape, including degree programs, certifications, and courses",
        "Expertise in managing product marketing funnels, conversion rate optimization, and data-driven decision-making",
        "Hands-on experience with marketing analytics tools (e.g., Google Analytics, Mixpanel, or similar)",
        "Proficiency in SEO and SEM with a track record of growing organic traffic",
        "Ability to drive projects from ideation to execution in a fast-paced environment",
        "Excellent communication and stakeholder management skills",
        "Familiarity with A/B testing and marketing automation tools is a plus",
      ],
      description: [
        "Develop and execute GTM strategies for online courses, certifications, and degree programs.",
        "Own and optimize acquisition, engagement, and conversion funnels with data-driven insights.",
        "Define and track key performance metrics (KPIs) for measuring GTM success and product adoption.",
        "Collaborate with cross-functional teams to ensure seamless execution of GTM plans.",
        "Conduct market research to understand competitive positioning, user needs, and emerging trends.",
        "Optimize lead nurturing strategies with A/B testing to improve conversion rates.",
        "Work closely with product and engineering teams to align product development with market needs.",
        "Drive customer insights and feedback loops to refine product offerings and enhance user experience.",
        "Develop and implement SEO and SEM strategies for organic traffic growth and discoverability.",
      ],
      location: "Remote/Onsite, India",
    };

    const sportsPerformanceAnalyst = {
      id: 0,
      jobTitle: "Sports Performance Analyst",
      skill: [
        "3–8 years of experience in performance analysis, sports analytics, or sports science in one or more of: cricket, tennis, badminton, football, or other elite sport",
        "Proficiency in video analysis tools (e.g., Hudl, Sportscode, Nacsport, LongoMatch) and/or data platforms (StatsBomb, CricViz, Hawk-Eye, or similar)",
        "Strong analytical and statistical skills; experience with data visualization and reporting (Excel, Tableau, Power BI, or similar)",
        "Understanding of sport-specific metrics, tactics, and KPIs across cricket, tennis, badminton, football, and other sports",
        "Ability to work under pressure and deliver within deadlines; excellent organization and attention to detail",
        "Strong verbal and written communication; ability to present insights clearly to coaches, players, and management",
        "Degree or certification in sports science, statistics, data analytics, or related field preferred",
        "Willingness to travel for camps and competitions as required",
      ],
      description: [
        "Analyze performance data and video for athletes and teams across cricket, tennis, badminton, football, and other sports to support selection, tactics, and player development.",
        "Design and implement performance analysis frameworks and metrics suited to each sport and competition context.",
        "Maximize use of performance technology (video analysis, tracking data, biometrics, analytics platforms) to plan and analyze individual and team performance.",
        "Support coaching staff with pre- and post-match analysis, opposition analysis, and trend reports; deliver insights in time for training and match preparation.",
        "Create and maintain dashboards, reports, and individually tailored performance insights for players and coaches.",
        "Schedule and support analysis for training sessions, camps, and matches; ensure timely delivery of outputs to coaching and support staff.",
        "Work with coaches and support staff to align analysis with training programmes, formations, match tactics, and player development plans.",
        "Stay updated on latest developments in sports analytics and performance technology across multiple sports; adapt best practices for continual improvement.",
        "Collaborate with medical, conditioning, and technical staff on availability, load, and readiness metrics where relevant.",
        "Present findings clearly to coaches, players, and management; maintain accurate records and documentation; support media and reporting requirements when required.",
      ],
      location: "Remote/Onsite, India",
    };

    async function fetchData() {
      try {
        const response = await fetch(
          "https://encyc-cdn.s3.amazonaws.com/public_asset/json/careers.json"
        );
        const data = await response.json();
        const jobs = {
          ...data?.jobs,
          EdTech: [edTechJobMathsSchools, growthManagerEdTech],
          "Sports Tech": [sportsPerformanceAnalyst],
        };
        setCareersData({ ...data, jobs });
        setSelected(Object.keys(jobs)[0]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  if (isEmpty(careersData)) {
    return null;
  }

  return (
    <div>
      <div>
        <div className={`${styles.container} mt-5 section__margin`}>
          <div className={styles["careersWrapper"]}>
            <h1>{careersData.title}</h1>
            <br></br>
            <p>
              {careersData.description}
              <a
                className={styles["linkStyle"]}
                href={`mailto:${careersData.email}`}
                target="_blank"
                rel="noreferrer"
                style={{ marginLeft: "5px" }}
              >
                {careersData.email}
              </a>
            </p>
          </div>

          <div className={styles.careersLayout}>
            <aside className={styles.sidebar}>
              <nav className={styles.sidebarNav}>
                {Object.keys(careersData.jobs).map((category) => (
                  <button
                    type="button"
                    onClick={() => setSelected(category)}
                    className={`${styles.sidebarItem} ${
                      selected === category ? styles.sidebarItemActive : ""
                    }`}
                  >
                    {category.replace("_", " ")}
                  </button>
                ))}
              </nav>
            </aside>
            <div className={styles.jobs}>
            {careersData.jobs[selected]?.map((job) => {
              const { id, jobTitle, skill, location, description } = job;
              return (
                <div key={id} className={styles.job}>
                  <div className={styles.location}>
                    <div>
                      <FaGlobeAsia />
                    </div>
                    <span>{location}</span>
                  </div>
                  <div className={styles.jobTitle}>{jobTitle}</div>
                  <br />
                  {skill?.length && (
                    <>
                      <div className={styles.subHeadings}>Skills</div>
                      <div className={styles.skill}>
                        {skill?.map((ele) => (
                          <li>{ele}</li>
                        ))}
                      </div>
                    </>
                  )}
                  <br />
                  {description?.length && (
                    <>
                      <div className={styles.subHeadings}>Description</div>
                      <div className={styles.skill}>
                        {description?.map((ele) => (
                          <li>{ele}</li>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
